module.exports = __webpack_public_path__ + "static/media/lightBackGround.53c4c500.png";